module.exports = __webpack_public_path__ + "img/partner-goatv.3c976c7b.png";